export const HGT = 'heatmap-generation';
export const ACCESS_MANAGEMENT = 'access-management';
export const LEGAL_AGREEMENTS = 'legal-agreements';